export const getOpenState = (value: boolean) => (value ? "open" : "closed");
